import { Swiper } from 'swiper';

class GallerySwiper {
  constructor(element) {
    if (!(element instanceof HTMLElement)) {
      throw new TypeError('Invalid element');
    }
    this.element = element;
    this.parent = element.closest('.section--gallery');

    this.initSwiper();
  }

  initSwiper() {
    const index = Array.from(this.parent.querySelectorAll('.gallery-swiper') ?? []).indexOf(this.element);
    const isOdd = index % 2;
    const isCentered = document.body.id !== 'winter-wonderland-landing-page';
    // console.log('Is Odd?: ', isOdd ? 0 : 1);

    this.swiper = new Swiper(this.element, {
      slidesPerView: 'auto',
      spaceBetween: 20,
      initialSlide: isOdd ? 0 : 1,
      centeredSlides: isCentered,
      loop: true,
    });
  }
}

export default GallerySwiper;
